import { AbstractDocumentItemAlert } from ".";
import { ICompareDateValidatable, IItem } from "../items";

export class CompareDateAlert extends AbstractDocumentItemAlert<IItem & ICompareDateValidatable> {
  constructor(itemSetId: number, item: IItem & ICompareDateValidatable) {
    super(itemSetId, item, false);
  }

  get kind(): string {
    return "日付比較";
  }

  get target(): string {
    return "日付比較「"
      + (this._detectedItem.name ? this._detectedItem.name : "")
      + "」";
  }

  get description(): string {
    // TODO: 条件を表示してあげないとなんでNGなのか分からないが、現状では計算式の材料の情報を持ってきていない
    return "指定された条件に一致していません。";
  }
}
